@use "ui/styles/sizes";

.wrapper {
    > label {
        margin-bottom: sizes.$s4;
    }

    div.label {
        margin-bottom: 0;
    }

    :global {
        .label {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: sizes.$s3;
        }

        .tooltip {
            color: var(--secondary-text-color);
        }

        .error-text {
            color: red;
            font-size: 0.875rem;
            margin-top: 0.25rem;
        }
    }
}